import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance9mu49fvvgdlz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      n3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      c6r(writer, customScalarAdapters, value) {
        writer.q47('partyId');
        get_partyIdAdapter().o3z(writer, customScalarAdapters, value.s6p_1);
        writer.q47('playerId');
        get_playerIdAdapter().o3z(writer, customScalarAdapters, value.t6p_1);
        writer.q47('name');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.u6p_1);
        writer.q47('email');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.v6p_1);
        writer.q47('badge');
        Badge_ResponseAdapter_instance.e6l(writer, customScalarAdapters, value.w6p_1);
        writer.q47('callSignAdjective');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.x6p_1);
        writer.q47('callSignNoun');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.y6p_1);
        var tmp = value.z6p_1;
        if (tmp instanceof Present()) {
          writer.q47('imageURL');
          present(get_NullableStringAdapter()).x40(writer, customScalarAdapters, value.z6p_1);
        }
        var tmp_0 = value.a6q_1;
        if (tmp_0 instanceof Present()) {
          writer.q47('avatarType');
          present(get_NullableStringAdapter()).x40(writer, customScalarAdapters, value.a6q_1);
        }
        writer.q47('unvalidatedEmails');
        list(get_StringAdapter()).v40(writer, customScalarAdapters, value.b6q_1);
      }
      o3z(writer, customScalarAdapters, value) {
        return this.c6r(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instance3cegmft9cv7tf,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
